import { h } from 'preact'
import { attributesAnalytics } from '../../js/modules/component'

export const TuileImage2 = ({ image, alt, analytics, URL }) => {
   return (
      <a href={URL} class="tuile-image-2 lien-composite" {...attributesAnalytics(analytics)}>
         <div class="image-container">
            <img class="img" src={`${image}?saveas=webp`} alt={alt || ''} />
         </div>
      </a>
   )
}
